angular.module 'zc.users'

.directive 'zcMasterOnly', (Devise) ->
  restrict: 'A'
  link: (scope, elem, attrs) ->
    Devise.getCurrentUser().then (user) ->
      if not user or not Devise.isMaster()
        elem.css display: 'none'



// WEBPACK FOOTER //
// ./src/zenclerk_modules/users/directives/master_only.directive.coffee